import React, { useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { server_url } from "../../Utils/Helper";
import { toast } from "react-toastify";

const LibraryModal = () => {
  const [form, setForm] = useState({
    book_title: '',
    author_name: '',
    isbn: '',
    cover_img: '',
    borrower_name: '',
    date_borrowed: '',
    due_date: '',
    return_date: '',
    status: 'Available',
    record_id: null,
    qty: 0,
    price: 0,
    post_date: '',
    rack_no: '',
    publisher: '',
    author: '',
    subject: '',
    book_no: '',
  });

  const [isUploading, setIsUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState<string>('');
  // Handle file selection and upload
  const onSelectImageFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const attachmentFile = e.target.files ? e.target.files[0] : null;
    if (!attachmentFile) return;

    // Validate file size (5MB limit)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (attachmentFile.size > maxSize) {
      toast.error('File size exceeds the 5MB limit.');
      return;
    }
    const file = attachmentFile;
    if (file) {
      // Create a new FileReader to read the file
      const reader = new FileReader();

      // Set up onload event to update the preview when the file is read
      reader.onloadend = () => {
        setImagePreview(reader.result as string); // Set the result as the image URL
      };

      setIsUploading(true); // Set uploading state

      // Read the image file as a data URL
      reader.readAsDataURL(file);
    }
    // Prepare form data for upload
    setIsUploading(true);
    const formData = new FormData();
    formData.append('media', attachmentFile);

    // Upload the file
    fetch(server_url + "/upload_transfer_certificate-document", {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setForm((prevForm: any) => ({ ...prevForm, cover_img: data.url }));
        toast.success('Uploaded successfully');
      })
      .catch((error) => {
        console.error('Error uploading attachment:', error);
        toast.error('Failed to upload the file.');
      })
      .finally(() => {
        setIsUploading(false);
      });
  };
  // Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Logic for submitting form data
    console.log('Form submitted with data:', form);
    // Call API to save book details
  };

  return (
    <>
      <>
        {/* Book Details */}
        <div className="modal fade" id="book_details">
          <div className="modal-dialog modal-dialog-centered  modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">View Details</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <div className="view-book">
                  <div className="view-book-title">
                    <h5>Issue Book Details</h5>
                  </div>
                  <div className="book-issue-details">
                    <div className="book-details-head">
                      <span className="text-primary">IB853629</span>
                      <h6>
                        <span>Issue Date :</span> 19 May 2024
                      </h6>
                    </div>
                    <ul className="book-taker-info">
                      <li>
                        <div className="d-flex align-items-center">
                          <span className="student-img">
                            <ImageWithBasePath
                              src="https://imageplaceholder.net/300"
                              className="img-fluid rounded-circle"
                              alt="Img"
                            />
                          </span>
                          <h6>
                            Janet <br /> III, A
                          </h6>
                        </div>
                      </li>
                      <li>
                        <span>Roll No</span>
                        <h6>35010</h6>
                      </li>
                      <li>
                        <span>Book Name</span>
                        <h6>Echoes of Eternity</h6>
                      </li>
                      <li>
                        <span>Book No</span>
                        <h6>501</h6>
                      </li>
                      <li>
                        <span>Due Date</span>
                        <h6>19 May 2024</h6>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Book Details */}
      </>

      {/* Add Member */}
      <div className="modal fade" id="add_library_members">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Member</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Card No</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Date of Join</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="mb-0">
                      <label className="form-label">Phone Number</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <Link
                  to="#"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Add Member
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Add Member */}
      {/* Edit Member */}
      <div className="modal fade" id="edit_library_members">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Member</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Name"
                        defaultValue="Ahmad"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Card No</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Card No"
                        defaultValue={501}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Email"
                        defaultValue="james@example.com"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Date of Join</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Date of Join"
                        defaultValue="22 Apr 2024"
                      />
                    </div>
                    <div className="mb-0">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Phone Number"
                        defaultValue="+1 78429 82414"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <Link
                  to="#"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save Changes
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Edit Member */}

      <>
        {/* Add Book */}
        <div className="modal fade" id="add_library_book">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Book</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label>Cover Image:</label>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={onSelectImageFile}
                        />
                        {isUploading && <p>Uploading...</p>}
                        {/* Image preview */}
                        {imagePreview && (
                          <div className="image-preview mt-3">
                            <img
                              src={imagePreview}
                              alt="Preview"
                              style={{ maxWidth: '100%', maxHeight: '300px' }}
                            />
                          </div>
                        )}
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Book Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="book_title"
                          value={form.book_title}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Book No</label>
                            <input
                              type="text"
                              className="form-control"
                              name="book_no"
                              value={form.book_no}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Rack No</label>
                            <input
                              type="text"
                              className="form-control"
                              name="rack_no"
                              value={form.rack_no}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Publisher</label>
                        <input
                          type="text"
                          className="form-control"
                          name="publisher"
                          value={form.publisher}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Author</label>
                        <input
                          type="text"
                          className="form-control"
                          name="author"
                          value={form.author}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Subject</label>
                        <input
                          type="text"
                          className="form-control"
                          name="subject"
                          value={form.subject}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Qty</label>
                            <input
                              type="text"
                              className="form-control"
                              name="qty"
                              value={form.qty}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Status</label>
                            <input
                              type="text"
                              className="form-control"
                              name="available"
                              value={form.status}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Price</label>
                        <input
                          type="text"
                          className="form-control"
                          name="price"
                          value={form.price}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-0">
                        <label className="form-label">Post Date</label>
                        <input
                          type="text"
                          className="form-control"
                          name="post_date"
                          value={form.post_date}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <Link to="#" className="btn btn-light me-2" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="submit" className="btn btn-primary">
                    Add Book
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Add Book */}
        {/* Edit Book */}
        {/* <div className="modal fade" id="add_library_book">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Book</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label>Cover Image:</label>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={onSelectImageFile}
                        />
                        {form.cover_img && (
                          <div className="image-preview mt-3">
                            <img
                              src={URL.createObjectURL(imagePreview)}
                              alt="Preview"
                              style={{ maxWidth: '100%', maxHeight: '300px' }}
                            />
                          </div>
                        )}
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Book Title</label>
                        <input
                          type="text"
                          name="book_title"
                          value={form.book_title}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter Book Title"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Author Name</label>
                        <input
                          type="text"
                          name="author_name"
                          value={form.author_name}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter Author Name"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">ISBN</label>
                        <input
                          type="text"
                          name="isbn"
                          value={form.isbn}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter ISBN"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Borrower Name</label>
                        <input
                          type="text"
                          name="borrower_name"
                          value={form.borrower_name}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter Borrower Name"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Date Borrowed</label>
                        <input
                          type="date"
                          name="date_borrowed"
                          value={form.date_borrowed}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Due Date</label>
                        <input
                          type="date"
                          name="due_date"
                          value={form.due_date}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Return Date</label>
                        <input
                          type="date"
                          name="return_date"
                          value={form.return_date}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Status</label>
                        <select
                          name="status"
                          value={form.status}
                          onChange={handleChange}
                          className="form-control"
                        >
                          <option value="Available">Available</option>
                          <option value="Checked Out">Checked Out</option>
                          <option value="Reserved">Reserved</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Add Book
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div> */}
        {/* Edit Book */}
      </>

      {/* Delete Modal */}
      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form>
              <div className="modal-body text-center">
                <span className="delete-icon">
                  <i className="ti ti-trash-x" />
                </span>
                <h4>Confirm Deletion</h4>
                <p>
                  You want to delete all the marked items, this cant be undone
                  once you delete.
                </p>
                <div className="d-flex justify-content-center">
                  <Link
                    to="#"
                    className="btn btn-light me-3"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Yes, Delete
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Delete Modal */}
    </>
  );
};

export default LibraryModal;
